import './src/fonts/fonts.css' // currently used for some very general CSS rules
import OptimizelyProvider from './wrapRootElement'

export const wrapRootElement = OptimizelyProvider
